import projection from '../generated/pwg203f1.json';
import { AcceptanceManifest } from '../types';

export const pwg203f1AcceptanceManifest = projection as AcceptanceManifest;
